import React from "react";
import { TableProperties } from "lucide-react";

/* ===================== COMPONENTS ===================== */
import { TableSkeleton } from "../Skeleton/StatsSkeleton";

/* ===================== STYLES ===================== */
import styles from "./RequestBodyParams.module.scss";

const RequestBodyParams = ({ params = [], isAdminView = false, code }) => {
  const loading = !params || params.length === 0;
  const columns = isAdminView ? 7 : 6;

  return (
    <div className={styles["admin-req-body-params__card"]}>
      {/* HEADER */}
      <div className={styles["admin-req-body-params__header"]}>
        <div className={styles["admin-req-body-params__icon-wrapper"]}>
          <TableProperties size={18} strokeWidth={2.5} />
        </div>
        <h3 className={styles["admin-req-body-params__title"]}>
          Request Body Parameters
        </h3>
      </div>

      {/* TABLE */}
      <div className={styles["admin-req-body-params__table-wrapper"]}>
        <table className={styles["admin-req-body-params__table"]}>
          <thead>
            <tr>
              <th className={styles["admin-req-body-params__th"]}>Title</th>
              <th className={styles["admin-req-body-params__th"]}>Name</th>
              {isAdminView && (
                <th className={styles["admin-req-body-params__th"]}>
                  Vendor Key
                </th>
              )}
              <th className={styles["admin-req-body-params__th"]}>Value</th>
              <th className={styles["admin-req-body-params__th"]}>Data Type</th>
              <th className={styles["admin-req-body-params__th"]}>Required</th>
              <th className={styles["admin-req-body-params__th"]}>
                Description
              </th>
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td
                  colSpan={columns}
                  className={styles["admin-req-body-params__td"]}
                >
                  <TableSkeleton columns={columns} rows={3} />
                </td>
              </tr>
            ) : params.length > 0 ? (
              params.map((item, index) => (
                <tr key={index} className={styles["admin-req-body-params__tr"]}>
                  <td className={styles["admin-req-body-params__td"]}>
                    <span className={styles["admin-req-body-params__name"]}>
                      {item.title}
                    </span>
                  </td>

                  <td className={styles["admin-req-body-params__td"]}>
                    <span className={styles["admin-req-body-params__name"]}>
                      {item.name}
                    </span>
                  </td>

                  {isAdminView && (
                    <td className={styles["admin-req-body-params__td"]}>
                      {item.vendor_key || "--"}
                    </td>
                  )}

                  <td className={styles["admin-req-body-params__td"]}>
                    <span className={styles["admin-req-body-params__value"]}>
                      {item.value || "--"}
                    </span>
                  </td>

                  <td className={styles["admin-req-body-params__td"]}>
                    <span
                      className={`${styles["admin-req-body-params__badge"]} ${styles["admin-req-body-params__badge--type"]}`}
                    >
                      {item.data_type}
                    </span>
                  </td>

                  <td className={styles["admin-req-body-params__td"]}>
                    <span
                      className={`${styles["admin-req-body-params__badge"]} ${
                        item.required
                          ? styles["admin-req-body-params__badge--req-yes"]
                          : styles["admin-req-body-params__badge--req-no"]
                      }`}
                    >
                      {item.required ? "Yes" : "No"}
                    </span>
                  </td>

                  <td className={styles["admin-req-body-params__td"]}>
                    {item.description || "--"}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan={columns}
                  className={styles["admin-req-body-params__empty"]}
                >
                  No request body parameters available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default RequestBodyParams;
